import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { standardCommand } from '../../../core/model/command';
import { LanguageService } from '../../../core/service/language.service';
import { BuildingSpaceTypeService } from '../../service/data/building-space-type.service';
import { BuildingSpaceType } from '../../model/building-space-type';

@Component({
    selector: 'app-building-space-type-form',
    templateUrl: './building-space-type-form.component.html',
    styleUrls: ['./building-space-type-form.component.scss'],
    providers: [DeleteFormCommandHandler, FormCommandHandlerResolver, { provide: DataService, useExisting: BuildingSpaceTypeService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuildingSpaceTypeFormComponent extends FormComponentBase<BuildingSpaceType> {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    service: BuildingSpaceTypeService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, commandDispatcher, handlerResolver);
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
  }

  protected createModel(): BuildingSpaceType {
    return new BuildingSpaceType();
  }

  protected getFormGroup(): FormGroup {
    return this._fb.group({
      caption: this._fc.createWithOptions('BUILDING_SPACE_TYPE.CAPTION', this.dataContext.caption, { required: true, length: 50 }),
      bsabCode: this._fc.createWithOptions('BUILDING_SPACE_TYPE.BSAB_CODE', this.dataContext.bsabCode, { length: 10 }),
    });
  }
}
